import React from "react";
import { Shield } from "lucide-react";
import { TIERS } from "@/lib/pricing";
import { cn } from "@/lib/utils";

const TierCard = ({ tier, selected, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(tier.key)}
    className={cn(
      "relative w-full text-left rounded-[12px] p-7 border transition-all duration-200 ease-smooth",
      selected
        ? "bg-bg-secondary border-accent-pink shadow-pink-glow-lg"
        : "bg-bg-primary border-border-default hover:border-accent-pink/60"
    )}
    data-testid={`tier-card-${tier.key}`}
    aria-pressed={selected}
  >
    {tier.badge && (
      <span className="absolute top-3 right-3 bg-accent-pink text-[#091424] font-bold text-[10px] tracking-wider px-2 py-1 rounded">
        {tier.badge}
      </span>
    )}
    <div className="flex justify-center">
      <Shield size={32} strokeWidth={2} style={{ color: tier.color }} />
    </div>
    <div
      className="mt-4 text-center font-bold text-[11px] tracking-[0.1em]"
      style={{ color: tier.color }}
    >
      {tier.label}
    </div>
    <div className="mt-3 text-center text-white font-semibold text-[13px]">
      Query frequency: <span className="jea-mono text-accent-pink">{tier.frequency}</span>
    </div>
    <p className="mt-2 text-center text-text-secondary text-[13px] leading-5">{tier.description}</p>
  </button>
);

const TierStep = ({ data, patchSection, accountType, debtorCount }) => {
  const showAssignNote = accountType === "pro" || (debtorCount || 0) > 1;
  const tier = data.tier || null;

  return (
    <div className="space-y-6" data-testid="tier-step">
      <div className="space-y-2">
        <h2 className="text-white font-bold text-[22px]">Choose Your Query Frequency</h2>
        <p className="text-text-secondary text-[15px]">
          Your tier controls how often the platform automatically runs broker queries on each debtor.
        </p>
      </div>

      <div className="grid grid-cols-3 gap-4" data-testid="tier-cards">
        {TIERS.map((t) => (
          <TierCard
            key={t.key}
            tier={t}
            selected={tier === t.key}
            onSelect={(k) => patchSection && patchSection("tier", k)}
          />
        ))}
      </div>

      {showAssignNote && (
        <p
          className="text-center italic text-[13px] text-text-secondary"
          data-testid="tier-per-debtor-note"
        >
          You will assign a tier to each debtor individually after setup.
        </p>
      )}
    </div>
  );
};

// PatchSection helper delegates to setSection because tier is not an object.
export const patchTier = (setSection) => (_, value) => setSection("tier", value);

export default TierStep;
